<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="deletegeofence"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      :class="{ show: show }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="display: flex; justify-content: center"
      >
        <div class="modal-content" id="modal">
          <div class="card-body">
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <div
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin-bottom: 30px"
              class="mb-4"
            >
              <h4>{{ $t("delete-geofence") }}</h4>
            </div>

            <div
              class="col-md-8 col-sm-10 text-center mx-auto"
              style="margin-bottom: 40px"
            >
              <h5>{{ $t("are-you-sure") }}</h5>
              <p>
                {{ $t("delete-geofence-msg") }}
              </p>
            </div>

            <div
              class="mb-0"
              style="display:flex; justify-content: space-between"
            >
              <button @click="onCancel" type="button" class="btn btn-secondary">
                {{ $t("cancel") }}
              </button>
              <button @click="deletegeofence" class="btn btn-danger">
                {{ $t("delete-geofence") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "DeletePOIModal",
  components: {
    Loading,
  },
  props: {
    show: Boolean,
    point: Object,
    id: String,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      mssg: "",
      Errormssg: "",
    };
  },
  methods: {
    ...mapActions(["deleteGeofence", "fetchGeofence"]),
    onCancel() {
      this.$emit("closeDeleteGeofenceModal");
    },
    deletegeofence() {
      // console.log("deleted");
      // console.log(this.id);
      this.isLoading = true;
      this.deleteGeofence(this.id)
        .then((res) => {
          this.fetchGeofence();
          this.isLoading = false;
          this.mssg = res.data.payload.message;
          setTimeout(() => {
            this.isLoading = true;
          }, 500);
          setTimeout(() => {
            this.onCancel();
          }, 2000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
};
</script>

<style></style>
